import type { Currency } from '@ps/web-core-enums';
import { Translation } from '@ps/web-shared-components';
import React from 'react';

import CurrencyAmount from '@swf/components/CurrencyAmount/CurrencyAmount';
import CashSVG from '@swf/components/StarsMPNotification/assets/icons/cash-split-wager-ib-icon.svg';
import CIBSVG from '@swf/components/StarsMPNotification/assets/icons/casino-split-wager-ib-icon.svg';

import { formatPercent } from '../../utils';
import Circle from '../ProgressCircle/ProgressCircle';

import {
  TXTWCL_Total_Bonus_Package,
  TXTWCL_We_add,
  TXTWCL_You_give,
  TXTWCL_Your_bets_and_winnings_will_be_ELL
} from './SplitWagerExplainer.messages.json';
import Styles from './SplitWagerExplainer.scss';

interface PieceProps {
  cost: number;
  currency: string;
  textTag: { id: string; defaultMessage: string };
  locale: string;
  Icon: React.FC;
  symbol?: string;
}
const SplitWagerPiece: React.FC<PieceProps> = ({ cost, currency, textTag, Icon, symbol }) => (
  <div className={Styles.bonusPackagePiece}>
    <div className={Styles.iconPiece}>
      <Icon />
      {symbol && <div className={Styles.symbol}>{symbol}</div>}
    </div>
    <div className={Styles.cashText}>
      <CurrencyAmount
        value={cost}
        currency={currency as Currency}
        minimumFractionDigits={Number.isInteger(cost / 100) ? 0 : 2}
      />
    </div>
    <div className={Styles.percentText}>
      <Translation {...textTag} />
    </div>
  </div>
);

/**
 * SplitWager diagram
 */
interface ExplainerProps {
  cost: number;
  topUp: number;
  costRatio: number;
  topUpRatio: number;
  currency: Currency;
  locale: string;
}
const SplitWagerExplainer: React.FC<ExplainerProps> = ({
  cost,
  topUp,
  costRatio,
  topUpRatio,
  currency,
  locale
}) => (
  <div className={Styles.wrapper}>
    <div className={Styles.innerContainer}>
      <div className={Styles.flexContainer}>
        <SplitWagerPiece
          cost={cost}
          currency={currency}
          locale={locale}
          textTag={TXTWCL_You_give}
          Icon={CashSVG}
          symbol="+"
        />
        <SplitWagerPiece
          cost={topUp}
          currency={currency}
          locale={locale}
          textTag={TXTWCL_We_add}
          Icon={CIBSVG}
          symbol="="
        />
        <SplitWagerPiece
          cost={cost + topUp}
          currency={currency}
          locale={locale}
          textTag={TXTWCL_Total_Bonus_Package}
          Icon={() => (
            <Circle progressColor="#6DD663" baseColor="#8838CD" progressPercentage={costRatio} />
          )}
        />
      </div>
      <div className={Styles.footerText}>
        <Translation
          {...TXTWCL_Your_bets_and_winnings_will_be_ELL}
          values={{
            0: formatPercent(costRatio, locale, 2),
            1: formatPercent(topUpRatio, locale, 2)
          }}
        />
      </div>
    </div>
  </div>
);

export default SplitWagerExplainer;
